import { queryOptions } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { Catalog } from '@erp/shared';

export function catalogsListOptions() {
  return queryOptions({
    queryKey: ['erp', 'catalogs', 'list'] as const,
    queryFn: async ({ signal }) => {
      const res = await api<Catalog[]>('/catalogs', { signal });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}

// A árvore do catálogo (GET /catalogs/:id) vive em uma única query:
// catalogTreeQuery, em @/features/tickets/tickets-queries.
